export function PageHeader({
  action,
  description,
  eyebrow = "WhatStar command center",
  meta,
  title,
}: {
  action?: React.ReactNode;
  description: string;
  eyebrow?: string;
  meta?: React.ReactNode;
  title: string;
}) {
  return (
    <header className="wr-page-header">
      <div className="wr-page-header__copy">
        <span className="wr-page-header__eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        <p>{description}</p>
        {meta ? <div className="wr-page-header__meta">{meta}</div> : null}
      </div>
      {action ? <div className="wr-page-header__actions">{action}</div> : null}
    </header>
  );
}
